// Purpose: click-through consent-to-monitor gate (NIST 800-171 3.1.9 /
// AC-8). Wraps the design-system Modal to show the current system-use
// notice; on acknowledge it records the ack (session-scoped) and calls
// onAcknowledge(); on cancel/Escape/backdrop it calls onClose().
//
// Padding notes: Modal already applies px-5 py-4 to its children slot and
// px-5 py-3 (flex row, justify-end) to its footer slot, so we do NOT add
// extra padding here — doing so would double-pad.

import { Link } from 'react-router-dom';
import { SYSTEM_USE_NOTICE } from '@ast/legal-notices';
import { recordSystemUseAck } from '../../lib/systemUseAck.ts';
import { NoticeRenderer } from './NoticeRenderer.tsx';
import { Modal } from '../ui/Modal.tsx';
import { Button } from '../ui/Button.tsx';

export interface SystemUseGateProps {
  open: boolean;
  onAcknowledge: () => void;
  onClose: () => void;
}

export function SystemUseGate({ open, onAcknowledge, onClose }: SystemUseGateProps) {
  function handleAck() {
    recordSystemUseAck(SYSTEM_USE_NOTICE.version);
    onAcknowledge();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={SYSTEM_USE_NOTICE.title}
      size="lg"
      footer={
        <>
          <Button variant="secondary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="md" onClick={handleAck} autoFocus>
            I acknowledge and consent
          </Button>
        </>
      }
    >
      <div className="max-h-[60vh] overflow-y-auto">
        <NoticeRenderer notice={SYSTEM_USE_NOTICE} />
        <p className="text-body-s text-fg-muted mt-4">
          See the full{' '}
          <Link to="/notice" className="underline text-accent-primary">
            privacy notice and terms
          </Link>
          .
        </p>
      </div>
    </Modal>
  );
}
